import { useEffect } from "react";
import { useNavigate } from "react-router";

import { Page } from "components/shared/Page";
import { useAuthContext } from "app/contexts/auth/context";
import { useAuthModalContext } from "app/contexts/authModal/context";
import HowWouldTheySeeIt from "app/pages/raajneeti/currentAffairs/howTheySee";

import "app/publicpages/Home.scss";
import "app/pages/raajneeti/currentAffairs/currentAffairs.scss";

const readSavedTheme = () => {
  try {
    if (!localStorage.getItem("RAAJNEETI_NAVY_DEFAULT_V1")) return "navy";
    return localStorage.getItem("RAAJNEETI_LANDING_THEME") === "light" ? "light" : "navy";
  } catch {
    return "navy";
  }
};

const HowTheySeePublic = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuthContext();
  const { openAuthModal } = useAuthModalContext();

  useEffect(() => {
    document.body.classList.toggle("theme-navy", readSavedTheme() === "navy");
    return () => document.body.classList.remove("theme-navy");
  }, []);

  const enterApp = () => {
    if (isAuthenticated) {
      navigate("/raajneeti/home");
    } else {
      openAuthModal({
        label: "Learning PSIR",
        onSuccess: () => navigate("/raajneeti/home"),
      });
    }
  };
  const exitApp = () => navigate("/");

  return (
    <Page title="How Would They See It - Raajneeti AI">
      <div className="home-wrapper">
        <link
          href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,600;0,700;1,600&family=IBM+Plex+Sans:wght@400;500;600;700&family=IBM+Plex+Mono:wght@400;500;600&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/@tabler/icons-webfont@3.10.0/dist/tabler-icons.min.css"
        />

        <nav className="pub-nav" id="pub-nav">
          <div className="pub-nav-brand" onClick={exitApp}>
            Raajneeti <b>AI</b>
          </div>
          <div className="pub-nav-links">
            <button onClick={() => navigate("/just-curious")}>Explore</button>
            <button type="button" className="pub-nav-soon" aria-disabled="true">
              GS Current Affairs <span className="nav-soon-pill">Coming soon</span>
            </button>
            <button
              className="pub-nav-ai"
              onClick={() => navigate("/raajneeti/ai-samiksha")}
            >
              <i className="ti ti-sparkles"></i> AI समीक्षा
            </button>
          </div>
          <button className="pub-nav-cta" onClick={enterApp}>
            Learning PSIR <i className="ti ti-arrow-right"></i>
          </button>
        </nav>

        <div
          className="ca-scope transition-content w-full pb-8"
          style={{ paddingTop: 80, minHeight: "100vh", background: "var(--bg)" }}
        >
          <div className="sec-head-bar" style={{ position: "relative" }}>
            <button
              type="button"
              className="as-back"
              onClick={() => navigate("/just-curious")}
            >
              <i className="ti ti-arrow-left" /> All tools
            </button>
            <h2>
              <i className="ti ti-users" /> How Would They See It
            </h2>
            <p className="shb-tag">
              One headline. Three minds. Three different verdicts.
            </p>
          </div>

          <HowWouldTheySeeIt />
        </div>
      </div>
    </Page>
  );
};

export default HowTheySeePublic;